import React, {useEffect, useState} from 'react';
import root from 'window-or-global';
import Url from '../../../constants/Url';
import Message from '../../../components/common/Message';
import {Icon, svgs} from 'epic-diesel-common/src';
import {transformAmount} from '../../../utils/PayoutUtils';
import {PayoutReport} from '../../../../shared/types/payout/PayoutAdmin';

//@ts-ignore
import styles from './PayoutReport.pcss';

export interface PayoutReportDetailProps {
    expanded: boolean;
    reportDetailInfo: PayoutReport[];
}

const PayoutReportDetail: React.FC<PayoutReportDetailProps> = ({expanded, reportDetailInfo}) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (reportDetailInfo) {
            setLoading(false);
        }
    }, [reportDetailInfo]);

    if (!expanded) {
        return null;
    }

    if (loading) {
        return (
            <div className={styles.loader}>
                <Icon className={styles.icon} icon={svgs.LOADING} fontSize="large" />
            </div>
        );
    }

    const handleClickDownloadReport = date => {
        root.open(`${Url().DOWNLOAD_PAYOUT_REPORT}?payoutPeriod=${date}`);
    };

    return (
        <>
            {reportDetailInfo.length ? (
                <>
                    <div key="report-detail-header" className={styles.reportItemHeader}>
                        <p>
                            <Message code="label.affiliate.form.payoutReport.payoutReportTitle" />
                        </p>
                        <p />
                        <p />
                        <p />
                        <div className={styles.action} />
                    </div>
                    {reportDetailInfo.map((detail, i) => {
                        const reportItemClass =
                            i + 1 === reportDetailInfo.length
                                ? styles.reportItemLast
                                : styles.reportItem;
                        return (
                            <div key={detail.reportId} className={reportItemClass}>
                                <p />
                                <p />
                                <p>{detail.period}</p>
                                <p>{transformAmount(detail.amount)}</p>
                                <div className={styles.action}>
                                    <button
                                        type="button"
                                        onClick={() => handleClickDownloadReport(detail.period)}
                                        className={styles.downloadButton}>
                                        <Icon icon={svgs.DOWNLOAD} />
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </>
            ) : (
                <div className={styles.reportItemLast}>
                    <p>
                        <Message code="epic.affiliate.form.payout.empty.v2" />
                    </p>
                </div>
            )}
        </>
    );
};

export default PayoutReportDetail;
